/**
 * Which catalogue rows the app pickers show.
 *
 * An Android row exists only to receive its Adapty events (Settings →
 * Integrations → per-app webhook URL). Every screen with a picker — Overview,
 * Ads Manager, Campaign Studio, rules, tester, settings — is built on Apple
 * Ads data, which an Android app never has, so there it would only offer a
 * page of zeros (owner, 2026-10-22: Android must not appear in the pickers).
 * The per-app URL card reads the full catalogue instead.
 */
import type { App } from "./types";

export function pickerApps(apps: App[]): App[] {
  return apps.filter((a) => a.platform !== "android");
}
